export class Product {
    id: number;
    description: string
    discontinued: boolean
    displayName: string
    ean: string
    categoryId: number
    foodToGoCategoryId: number
    categoryKioskId: string
    managed: boolean
    name: string
    price: number
    productCode: string
    sortOrder: string
    allergensApiProductId: string
    enabled: boolean
    ageRestriction: string
    ingredients: string
    nutrition: string
  }



// WEBPACK FOOTER //
// ./src/app/_models/product.model.ts